export const breadcrumb = {
  title: 'Nomor telepon',
  number: {
    buy: 'Beli',
    index: 'Daftar'
  }
};
